export const isEmail = (value = '') => {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/.test(value);
}

export const isThreeNumbers = (value = '') => {
  return /^\d{3}$/.test(value)
}

export const isExpiryDate = (value = '') => {
  const expiryDate = value.split('/').join('').trim()
  return /^(?:[0-1][0-9][0-9][0-9])$/.test(expiryDate)
}

export const isFilledOut = (value = '') => {
  return !!value.length
}

export const isCardNumber = (value = '') => {
  if (value.startsWith('4')) {
    return /^(?:[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{4})$/.test(value)
      || /^(?:4[0-9]{3}-[0-9]{4}-[0-9]{4}-[0-9]{1,4})$/.test(value)
      || /^(?:4[0-9]{3}-[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{1,3})$/.test(value)
  }

  const cardNumber = value.split('-').join('')
  return value.includes('-')
    ? /^(?:[0-9]{4}-[0-9]{4}-[0-9]{4}-[0-9]{4})$/.test(value)
    : /^\d{12,19}$/.test(cardNumber)
}

const isValidInput = ({ value = '', type = '' }) => {
  let message = ''

  switch (type) {

    case 'email':
      if (!isEmail(value)) {
        message = 'Netfang er ekki gilt'
      }
      break
    case 'zip':
      if (!isThreeNumbers(value)) {
        message = 'Póstnúmer er ekki gilt'
      }
      break
    case 'cvc':
      if (!isThreeNumbers(value)) {
        message = 'Öryggisnúmer er ekki gilt'
      }
      break
    case 'expiry':
      if (!isExpiryDate(value)) {
        message = 'Gildistími er ekki gildur'
      }
      break
    case 'required':
      if (!value.length) {
        message = 'Upplýsingar vantar'
      }
      break
    case 'card':
      if (!isCardNumber(value)) {
        message = 'Kortanúmer er ekki gilt'
      }
      break;
    case 'phone':
      if (value.length < 6) {
        message = 'Símanúmer þarf að vera a.m.k. 6 tölustafir á lengd'
      }
      break;
    case 'reference-number':
      if (value.length > 30) {
        message = 'Beiðnanúmer getur ekki verið meira en 30 stafir á lengd'
      }
      break;
    case 'reference':
      if (value.length > 35) {
        message = 'Tilvísun getur ekki verið lengri en 35 stafir á lengd'
      }
      break;
    default:
      break
  }

  return message
}

export const validateInput = ({ input, showError = true }: {
  input: HTMLInputElement,
  showError: boolean,
}) => {
  const { validation = '' } = input.dataset

  const errorMessage = isValidInput({
    value: input.value,
    type: validation,
  })

  if (!showError) return !errorMessage.length

  let parentElement = input.parentElement
  if (parentElement.classList.contains('input__inner')) {
    parentElement = parentElement.parentElement
  }
  if (!parentElement) return

  const errorMessageElement = parentElement.querySelector<HTMLParagraphElement>('.input__error-message')
  if (!errorMessageElement) return

  if (errorMessage.length) {
    parentElement.classList.add('input--error')
    errorMessageElement.innerText = errorMessage
    return false
  }

  parentElement.classList.remove('input--error')
  errorMessageElement.innerText = ''
  return true
}

export const validateInputs = ({ inputs = [], showErrors = false }: {
  inputs: Array<HTMLInputElement>,
  showErrors: boolean,
}) => {
  let formIsValid = true
  inputs.forEach(input => {
    const inputIsValid = validateInput({ input, showError: showErrors })
    if (!inputIsValid) formIsValid = false
  })

  if (!formIsValid && showErrors) {
    inputs.forEach(input => input.classList.add('autovalidate'))
  }
  return formIsValid
}
